<template>

<div>
  <LDBsTable
    url="arena/equipments"
    defaultSort="id"
    defaultOrder="desc"
    :query="queryToUse"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label for="serie">{{ $t('serie') }}</label>
      <input
        type="text"
        id="serie"
        name="serie"
        class="form-control"
        :placeholder="$t('ph_serie')"
        v-model="query.serie"
        @input="upper('serie')"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="version">{{ $t('version') }}</label>
      <Combobox
        class="bg-white"
        name='version'
        :placeholder="$t('select_a_item')"
        label="VER_DSC"
        :initial-value="query.version"
        :options="equipmentVersions"
        v-model="query.version"
        :reduce="version => version.id"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="eqp_srt">{{ $t('eqp_srt') }}</label>
      <input
        type="text"
        id="eqp_srt"
        name="eqp_srt"
        class="form-control"
        :placeholder="$t('ph_eqp_srt')"
        v-model="query.eqp_srt"
      >
    </div>

    <div class="form-group col-lg-3">
      <label for="phone">{{ $t('phone') }}</label>
      <input
        type="text"
        class="form-control"
        id="phone"
        name='phone'
        :placeholder="$t('ph_phone')"
        v-model="query.phone"
      />
    </div>

    <div class="form-group col-lg-3">
      <label for="operator">{{ $t('operator') }}</label>
      <input
        type="text"
        class="form-control"
        id="operator"
        name='operator'
        :placeholder="$t('ph_operator')"
        v-model="query.operator"
        @input="upper('operator')"
      />
    </div>

    <div class="form-group col-lg-6">
      <label for="client">{{ $t('client') }}</label>
      <Combobox
        class="bg-white"
        name='client'
        :placeholder="$t('select_a_item')"
        :options="clients"
        :initial-value="query.client"
        label="CLI_DSC"
        v-model="query.client"
        :reduce="client => client.CLI_ID"
      />
    </div>
  </LDBsTable>
</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import { mapState } from 'vuex'

export default {
  name: 'ArenaEquipmentList',

  components: {
    LDBsTable,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('serial'),
          field: 'id',
          sortable: true
        },
        {
          title: this.$t('version'),
          field: 'VER_DSC',
          sortable: false
        },
        {
          title: this.$t('eqp_srt'),
          field: 'EQP_SRT',
          sortable: true
        },
        {
          title: this.$t('phone'),
          field: 'EQP_TEL',
          formatter: function (_, row) {
            const values = []

            const { EQP_DDD, EQP_TEL } = row

            if (EQP_DDD) {
              values.push(`${EQP_DDD}`)
            }

            if (EQP_TEL) {
              values.push(EQP_TEL.replace(/\D/g, ''))
            }

            return values.length
              ? values.join('')
              : '-'
          },
          sortable: false
        },
        {
          title: 'PIN',
          field: 'EQP_PIN',
          sortable: true
        },
        {
          title: this.$t('operator'),
          field: 'EQP_OPC',
          sortable: true
        },
        {
          title: this.$t('createdAt'),
          field: 'EQP_DHS',
          formatter: function (value) {
            if (!value) {
              return '-'
            }

            try {
              const [year, month, day] = value.split('T')[0].split('-')
              const time = value.split('T')[1].split('.')[0]

              return `${day}/${month}/${year} ${time}`
            } catch (error) {
              return value
            }
          },
          sortable: true
        },
        {
          title: this.$t('client'),
          field: 'CLI_DSC',
          sortable: false
        },
        {
          title: 'EQP_MTC',
          field: 'EQP_MTC',
          sortable: false,
          visible: false
        },
        {
          title: 'EQP_PROT',
          field: 'EQP_PROT',
          sortable: false,
          visible: false,
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/arena/equipment/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'arena_equipamentos' }
      },
      queryToUse: {},
      query: {
        serie: '',
        version: undefined,
        eqp_srt: '',
        phone: undefined,
        operator: '',
        client: undefined
      }
    }
  },

  computed: {
    ...mapState({
      lastquery: state => state.filtershistory.query,
      contracts: state => state.contracts.all,
      clients: state => state.arena.clients,
      equipmentVersions: state => state.arena.equipmentVersions,
    })
  },

  methods: {
    clear() {
      this.query.serie = ''
      this.query.version = undefined
      this.query.eqp_srt = ''
      this.query.phone = undefined
      this.query.operator = ''
      this.query.client = undefined
    },

    upper(attr) {
      this.query[attr] = this.query[attr].toUpperCase()
    },
  },

  beforeMount() {
    this.queryToUse = this.lastquery['arenaequipment'] ? this.lastquery['arenaequipment'] : this.query
  },

  async mounted () {
    const { dispatch } = this.$store

    await Promise.all([
      dispatch('arena/fetchArenaEquipmentVersions'),
      dispatch('arena/fetchClients')
    ])

    if (this.lastquery['arenaequipment']) {
      for (const [key, value] of Object.entries(this.lastquery['arenaequipment'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query
  },

  destroyed () {
    this.$store.dispatch(
      'filtershistory/setQuery',
      {
        key: 'arenaequipment',
        query: this.query
      }
    )
  },
}

</script>
